<template>
  <button
    type="button"
    class="hamburger"
    :class="{ 'is-active': isActive }"
    :aria-expanded="isActive ? 'true' : 'false'"
    @click="toggleClick"
  >
    <lucide-icon
      :icon="isActive ? icons.panelLeftClose : icons.panelLeftOpen"
      :size="20"
      aria-hidden="true"
    />
  </button>
</template>

<script>
import { PanelLeftClose, PanelLeftOpen } from 'lucide'
import LucideIcon from '@/components/LucideIcon'

export default {
  name: 'Hamburger',
  components: { LucideIcon },
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icons() {
      return {
        panelLeftClose: PanelLeftClose,
        panelLeftOpen: PanelLeftOpen
      }
    }
  },
  methods: {
    toggleClick() {
      this.$emit('toggleClick')
    }
  }
}
</script>
